import React, { useEffect, useState } from 'react';
import { AccordeonMiContext } from "./AccordeonMi.context";
import { GroupeAccordeonsDefaultProps } from "./AccordeonMi.types";
var GroupeAccordeons = function (_a) {
    var Component = _a.as, children = _a.children, accordeonActif = _a.accordeonActif, className = _a.className;
    var _b = useState(accordeonActif), activeAccordeonAuto = _b[0], setActiveAccordeonAuto = _b[1];
    useEffect(function () {
        setActiveAccordeonAuto(accordeonActif);
    }, [accordeonActif, setActiveAccordeonAuto]);
    var handleAccordeon = function (id) {
        if (activeAccordeonAuto === id) {
            setActiveAccordeonAuto(undefined);
        }
        else {
            setActiveAccordeonAuto(id);
        }
    };
    var classGroupAccordeons = 'fr-accordions-group';
    if (className) {
        classGroupAccordeons += " ".concat(className);
    }
    // @ts-ignore
    return (React.createElement(Component, { className: classGroupAccordeons },
        React.createElement(AccordeonMiContext.Provider, { value: { activeAccordeonId: activeAccordeonAuto, handleAccordeon: handleAccordeon } }, children)));
};
GroupeAccordeons.defaultProps = GroupeAccordeonsDefaultProps;
export default GroupeAccordeons;
